module.exports = __webpack_public_path__ + "img/projects-bg-shape.2ab84435.png";